import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-433ca252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GraphBoard" }
const _hoisted_2 = { class: "GraphBoard__container" }
const _hoisted_3 = { class: "container__statuses" }
const _hoisted_4 = { class: "statuses__status" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Рейс который уехал по графику", -1))
const _hoisted_6 = { class: "statuses__status" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Предрейс без рейса", -1))
const _hoisted_8 = { class: "statuses__status" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Рейс уехал без графика", -1))
const _hoisted_10 = { class: "statuses__status" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Перенесенный предрейс", -1))
const _hoisted_12 = { class: "statuses__status" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Перенесен с опозданием", -1))
const _hoisted_14 = { class: "container__graph" }
const _hoisted_15 = { class: "graph__header" }
const _hoisted_16 = { class: "header__item" }
const _hoisted_17 = { class: "item__title" }
const _hoisted_18 = { class: "item__date" }
const _hoisted_19 = { class: "header__item" }
const _hoisted_20 = { class: "item__title" }
const _hoisted_21 = { class: "item__date" }
const _hoisted_22 = { class: "header__item" }
const _hoisted_23 = { class: "item__title" }
const _hoisted_24 = { class: "item__date" }
const _hoisted_25 = { class: "header__item" }
const _hoisted_26 = { class: "item__title" }
const _hoisted_27 = { class: "item__date" }
const _hoisted_28 = { class: "header__item" }
const _hoisted_29 = { class: "item__title" }
const _hoisted_30 = { class: "item__date" }
const _hoisted_31 = { class: "header__item" }
const _hoisted_32 = { class: "item__title" }
const _hoisted_33 = { class: "item__date" }
const _hoisted_34 = { class: "header__item" }
const _hoisted_35 = { class: "item__title" }
const _hoisted_36 = { class: "item__date" }
const _hoisted_37 = { class: "graph__board" }
const _hoisted_38 = {
  key: 0,
  class: "board__state"
}
const _hoisted_39 = {
  key: 0,
  class: "state__loading"
}
const _hoisted_40 = {
  key: 1,
  class: "state__failed text-red-500"
}
const _hoisted_41 = {
  key: 2,
  class: "state__empty"
}
const _hoisted_42 = {
  key: 1,
  class: "board__container"
}
const _hoisted_43 = { class: "container__column" }
const _hoisted_44 = { class: "container__column" }
const _hoisted_45 = { class: "container__column" }
const _hoisted_46 = { class: "container__column" }
const _hoisted_47 = { class: "container__column" }
const _hoisted_48 = { class: "container__column" }
const _hoisted_49 = { class: "container__column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pre_trip_status_icon = _resolveComponent("pre-trip-status-icon")!
  const _component_loader = _resolveComponent("loader")!
  const _component_board_item = _resolveComponent("board-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_pre_trip_status_icon, { status: { id: 2 } }),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_pre_trip_status_icon, { status: { id: 3 } }),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_pre_trip_status_icon, { status: { id: 4 } }),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_pre_trip_status_icon, { status: { id: 5 } }),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_pre_trip_status_icon, { status: { id: 6 } }),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(0))), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(0))), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(1))), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(1))), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(2))), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(2))), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(3))), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(3))), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(4))), 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(4))), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(5))), 1),
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(5))), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.getDayOfWeek(_ctx.getDay(6))), 1),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatDateToReadable(_ctx.getDay(6))), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          (_ctx.loading || _ctx.failed || _ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createVNode(_component_loader, { class: "primary" })
                    ]))
                  : (_ctx.failed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, " При получении данных произошла ошибка, обновите страницу "))
                    : (_ctx.items.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " У вас нет запланированных рейсов "))
                      : _createCommentVNode("", true)
              ]))
            : (_ctx.days.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[0]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[1]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[2]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[3]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[4]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[5]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByDate(_ctx.days[6]), (item) => {
                      return (_openBlock(), _createBlock(_component_board_item, {
                        key: item.id,
                        item: item,
                        onOpenDetails: _ctx.onOpenDetails,
                        onOpenTransfer: _ctx.onOpenTransfer
                      }, null, 8, ["item", "onOpenDetails", "onOpenTransfer"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}